import { application } from '@core/controllers/app';

application.register('dtfs-orders--order-items',
  require('./dtfs_orders/order_items_controller').default);
